import { createMuiTheme } from '@material-ui/core/styles';


export default function AdminTheme(theme)
{
    return createMuiTheme({
        ...theme,
        ButtonSpacing: "8px",
        ButtonDoubleSpacing: "16px",
        overrides: {
            MuiListItem: {
                root: {
                    "&$selected": {
                        backgroundColor: theme.ColorBlue,
                        color: "white",
                    },
                    "&:hover": {
                        color: theme.ColorBlue,
                    }, 
                },
            },
            MuiListItemIcon: {
                root: {
                    color: "inherit"
                }
            }
        }
    });
}